import { render } from "./MantraKinComponent.vue?vue&type=template&id=5f46c42b&scoped=true"
import script from "./MantraKinComponent.vue?vue&type=script&lang=js"
export * from "./MantraKinComponent.vue?vue&type=script&lang=js"

import "./MantraKinComponent.vue?vue&type=style&index=0&id=5f46c42b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f46c42b"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QLayout from 'quasar/src/components/layout/QLayout.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QLayout});
